/**
 * Parameter ID mapping for readable names
 * The actual parameter info (name, color, unit) comes from the API via RootStore.getParameterAndUnitInfo()
 */
export const PARAMETER_IDS = {
	PipeFillPercentage: 1170,
	WaterLevel: 189,
	WaterFlow: 191,
	WasteWaterFlow: 1176,
	RainIntensity: 204,
	AccumulatedWasteWaterVolume: 1177,
	AccumulatedInfiltrationWaterVolume: 1181,
	AccumulatedRainRunOffVolume: 1183,
} as const;

export type ParameterName = keyof typeof PARAMETER_IDS;
